import { BASE_URL } from '@/shared/api';

/**
 * Build absolute API URLs for Data Dimension Studio.
 * Relative `/api/...` hits app.datacord.com which serves SPA HTML (no API proxy).
 */
export function studioApiUrl(path: string): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  const configured = String(BASE_URL || '').replace(/\/$/, '');
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  if (configured && configured !== origin) {
    return `${configured}${p}`;
  }
  // Production website has no /api reverse-proxy — fall back to API host
  if (origin.includes('app.datacord.com') || origin.includes('railway.app')) {
    return `https://api.datacord.com${p}`;
  }
  return p;
}

export function studioAuthHeaders(): Record<string, string> {
  const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
